import { create } from "zustand";

type HelpCenterState = {
  visible: boolean;
  chatOpen: boolean;
  search: string;
  labels: string[];
  articleId: string;
  unreadCount: number;
  zendeskHasLoaded: boolean;
  wasDismissedForLogin: boolean;
  chatRequested: boolean;
};

type HelpCenterActions = {
  resetHelpCenter: () => void;
  openHelpCenter: (opts?: {
    search?: string;
    labels?: string[];
    articleId?: string;
  }) => void;
  closeHelpCenter: () => void;
  openHelpCenterChat: () => void;
  closeHelpCenterChat: () => void;
  setHelpCenterSearch: (search: string) => void;
  setHelpCenterLabels: (labels: string[]) => void;
  setHelpCenterArticleId: (articleId: string) => void;
  setUnreadCount: (count: number) => void;
  setZendeskHasLoaded: (loaded: boolean) => void;
  setVisible: (visible: boolean) => void;
  setWasDismissedForLogin: (v: boolean) => void;
  requestChat: () => void;
  clearChatRequest: () => void;
};

type HelpCenterStore = HelpCenterState & HelpCenterActions;

const initialState: HelpCenterState = {
  visible: false,
  chatOpen: false,
  search: "",
  labels: ["support"],
  articleId: "",
  unreadCount: 0,
  zendeskHasLoaded: false,
  wasDismissedForLogin: false,
  chatRequested: false,
};

export const useHelpCenterStore = create<HelpCenterStore>()((set) => ({
  ...initialState,

  resetHelpCenter: () =>
    set((state) => ({ ...initialState, chatRequested: state.chatRequested })),

  openHelpCenter: (opts = {}) =>
    set({
      visible: true,
      search: opts.search ?? "",
      labels: opts.labels ?? [],
      articleId: opts.articleId ?? "",
      chatOpen: false,
    }),

  closeHelpCenter: () =>
    set({
      visible: false,
      search: "",
      labels: [],
      articleId: "",
      chatOpen: false,
    }),

  closeHelpCenterChat: () =>
    set({
      chatOpen: false,
      search: "",
      labels: [],
      articleId: "",
    }),

  openHelpCenterChat: () => set({ chatOpen: true }),

  setHelpCenterSearch: (search) =>
    set({
      chatOpen: false,
      labels: [],
      articleId: "",
      search,
    }),

  setHelpCenterLabels: (labels) =>
    set({
      chatOpen: false,
      search: "",
      articleId: "",
      labels,
    }),

  setHelpCenterArticleId: (articleId) =>
    set({
      chatOpen: false,
      search: "",
      labels: [],
      articleId,
    }),

  setUnreadCount: (unreadCount) => set({ unreadCount }),

  setZendeskHasLoaded: (zendeskHasLoaded) => set({ zendeskHasLoaded }),

  setWasDismissedForLogin: (v) => set({ wasDismissedForLogin: v }),

  setVisible: (visible: boolean) => set({ visible }),

  requestChat: () => set({ chatRequested: true }),

  clearChatRequest: () => set({ chatRequested: false }),
}));
